import { env } from '@/env'

import type { NativeBridgeMessage } from './types'

declare global {
  interface Window {
    ReactNativeWebView?: { postMessage: (message: string) => void }
  }
}

export function sendToNative(message: NativeBridgeMessage): void {
  if (typeof window === 'undefined') return
  if (env.NODE_ENV === 'development') {
    console.log('[NativeBridge] send →', message)
  }
  window.ReactNativeWebView?.postMessage(JSON.stringify(message))
}
